/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
require('../modules/es7.map.to-json');
module.exports = require('../modules/$.core').Map;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/map.js
 ** module id = 1312
 ** module chunks = 0
 **/